module.exports = __webpack_public_path__ + "viasport-logo-se-831684be8821f2331325113241a6961b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viasport-logo-se.png
// module id = 1067
// module chunks = 0 1 2